import React from "react";
import {
  EyeIcon,
  ChartBarIcon,
  CurrencyDollarIcon,
} from "@heroicons/react/24/outline";
import { useTranslation } from "../../../contexts/TranslationContext";
import StatCard from "../../common/StatCard";

interface FormStatsProps {
  totalSubmissions: number;
  completedPayments: number;
  totalRevenue: number;
}

const FormStats: React.FC<FormStatsProps> = ({
  totalSubmissions,
  completedPayments,
  totalRevenue,
}) => {
  const { t } = useTranslation();

  const conversionRate =
    totalSubmissions > 0
      ? Math.round((completedPayments / totalSubmissions) * 100)
      : 0;

  return (
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
      <StatCard
        icon={EyeIcon}
        label={t("forms.detail.stats.totalSubmissions")}
        value={totalSubmissions}
        iconColor="text-gray-400"
      />
      <StatCard
        icon={ChartBarIcon}
        label={t("forms.detail.stats.completedPayments")}
        value={completedPayments}
        iconColor="text-green-400"
      />
      <StatCard
        icon={CurrencyDollarIcon}
        label={t("forms.detail.stats.totalRevenue")}
        value={`${totalRevenue.toFixed(2)} zł`}
        iconColor="text-green-400"
      />
      <StatCard
        icon={ChartBarIcon}
        label={t("forms.detail.stats.conversionRate")}
        value={`${conversionRate}%`}
        iconColor="text-blue-400"
      />
    </div>
  );
};

export default FormStats;
